import {IQueryParams} from "./Models/IQueryParams";
import {useMutation, useQuery, useQueryClient} from "react-query";
import {IPaginatedList} from "./Models/IPaginatedList";
import {apiCall} from "./BaseApi";
import {ShopifyOrderIntegrationDto} from "./Models/ShopifyOrderIntegrationDto";

export const SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY = 'SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY '
export const useShopifyOrderIntegrations = (queryable: Partial<IQueryParams> | null = null) => {
    return useQuery<IPaginatedList<ShopifyOrderIntegrationDto>>([SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY, queryable], async () => {
        return await apiCall<IPaginatedList<ShopifyOrderIntegrationDto>>({
            url: `/shopifyOrderIntegrations`,
            method: 'GET',
            queryParams: queryable
        })
    });
}

export const useShopifyOrderIntegration = (id: number) => {
    return useQuery<ShopifyOrderIntegrationDto>([SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY, id], async () => {
        return await apiCall<ShopifyOrderIntegrationDto>({
            url: `/shopifyOrderIntegrations/${id}`,
            method: 'GET',
        })
    });
}

export const useMutateShopifyOrderIntegration = () => {

    const queryClient = useQueryClient();

    return useMutation(async (shopifyOrderIntegration: ShopifyOrderIntegrationDto): Promise<ShopifyOrderIntegrationDto> => {
        if (!shopifyOrderIntegration.id) {
            return await apiCall<ShopifyOrderIntegrationDto>({
                url: `/shopifyOrderIntegrations`,
                method: 'POST',
                data: shopifyOrderIntegration
            })
        } else {
            return await apiCall<ShopifyOrderIntegrationDto>({
                url: `/shopifyOrderIntegrations/${shopifyOrderIntegration.id}`,
                method: 'PUT',
                data: shopifyOrderIntegration
            })
        }
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY)
        }
    })
}


export const useMigrateShopifyIntegration = () => {

    const queryClient = useQueryClient();

    return useMutation(async (shopifyOrderIntegration: ShopifyOrderIntegrationDto): Promise<ShopifyOrderIntegrationDto> => {
        return await apiCall<ShopifyOrderIntegrationDto>({
            url: `/shopifyOrderIntegrations/${shopifyOrderIntegration.id}/migrate`,
            method: 'POST',
            data: shopifyOrderIntegration
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY)
        }
    })
}



export const useAuthorizeLink = () => {

    const queryClient = useQueryClient();

    return useMutation(async (data: {clientId: string, websiteUrl: string}): Promise<string> => {

        const query = new URLSearchParams();

        query.append('clientId', data.clientId);
        query.append('websiteUrl', data.websiteUrl);

        return await apiCall<string>({
            url: `/shopifyOrderIntegrations/authorize?${query.toString()}`,
            method: 'POST',
            responseType: 'text'
        })
    }, {
        onSuccess: async () => {
            await queryClient.invalidateQueries(SHOPIFY_ORDER_INTEGRATIONS_CACHE_KEY)
        }
    })
}
